import Vue from 'vue';
import App from '@/app.vue';
import router from '@/router';
import * as uiv from 'uiv';
import store from '@/stores/store';
import { bytesToKilobytes, bytesToMegabytes, currencyFilter, dateFilter, dateTimeFilter } from '@/filters';
// @ts-ignore
import Autocomplete from 'v-autocomplete';
import 'v-autocomplete/dist/v-autocomplete.css';
import '@/scss/app.scss';
import VueYouTubeEmbed from 'vue-youtube-embed';
import './validation';

Vue.config.productionTip = false;

// @ts-ignore
Vue.use(uiv);
Vue.use(Autocomplete);
Vue.use(VueYouTubeEmbed, { global: true, componentId: 'youtube' });

Vue.filter('kb', bytesToKilobytes);
Vue.filter('mb', bytesToMegabytes);
Vue.filter('currency', currencyFilter);
Vue.filter('date', dateFilter);
Vue.filter('datetime', dateTimeFilter);

async function start(): Promise<void> {
    try {
        await store.dispatch('environment/fetchAsync');
        await store.dispatch('user/fetchMeAsync');
    } catch (e) {
        store.commit('setLoading', false);
        // NOTE(Dan): We may 401 due to not being logged in, so we still want the app to start.
    }

    store.commit('setLoading', false);

    const root = new Vue({
        router,
        store,
        el: '#app',
        render: (h) => h(App),
    });
}

start();
